const Connect = require("react-redux").connect;
const Portfolio = require("../components/Portfolio");
const CheckoutActions = require("actions/checkout");
const CroquisActions = require("actions/croquis");
const DialogActions = require("actions/dialog");

const internals = {};

internals.fetchPortfolioData = () => {
    return dispatch => {
        dispatch(CroquisActions.fetchCroquisData());
        dispatch(CroquisActions.fetchPurchasedData());
    };
};

internals.getSaved = list => {
    const saved = { ...list };
    delete saved.new;

    return saved;
};

internals.orderSaved = list => {
    // hack in descending order; set in response array from API, but undone
    // apparently by how numeric property ids are implicitly ordered
    // i.e. croquis ID set on state.all object in reducer
    // we sort by id b/c ids correspond to chronological order of creation
    const ms = m => {
        // Only upgraded Purchases have a dateUpgraded
        // Croquis should be ordered by most recently edited
        // Purchases should be ordered by most recent transaction (really, creation or upgrade)
        // Purchases are non-editable, so their dateModified should change only
        // due to internal / operational (not user-triggered) changes
        // draftId is a Purchase-only property
        const dt = m.draftId ? m.dateUpgraded || m.dateCreated : m.dateModified;
        return new Date(dt).getTime();
    };
    return Object.keys(list)
        .sort((id1, id2) => ms(list[id2]) - ms(list[id1]))
        .map(id => list[id]);
};

internals.mergeDownloadPackages = downloadPackages => {
    return list => {
        const dictionary = {};
        Object.keys(list).forEach(id => {
            dictionary[id] = {
                ...list[id],
                downloadPackage: downloadPackages[list[id].downloadPackage]
            };
        });
        return dictionary;
    };
};

internals.connect = Connect(
    state => ({
        croquisList: internals.orderSaved(
            internals.getSaved(state.croquis.all)
        ),
        numCredits:
            state.auth.credentials.user && state.auth.credentials.user.credits,
        purchasedList: internals.orderSaved(
            internals.mergeDownloadPackages(
                state.checkout.downloadPackages.dict
            )(internals.getSaved(state.croquis.purchased))
        )
    }),
    {
        fetchPortfolioData: internals.fetchPortfolioData,
        deleteClick: CroquisActions.deleteCroquis,
        onDownloadOptionsClick: croquisId => {
            return dispatch => {
                return dispatch(DialogActions.openDownloadDialog(croquisId));
            };
        },
        onTransactionClick: (transactionType, modelId) => {
            return (dispatch, getState) => {
                if (transactionType === "upgrade") {
                    // Upgrades are redeeming a premium download package by definition
                    const { downloadPackages } = getState().checkout;
                    dispatch(
                        CheckoutActions.selectDownloadPackage(
                            downloadPackages.byName.premium
                        )
                    );
                }
                dispatch(
                    CheckoutActions.startTransaction(transactionType, modelId)
                );
                dispatch(DialogActions.openTransactionDialog());
            };
        },
        onSeeWhatsIncluded: () => {
            return dispatch => {
                dispatch(DialogActions.openWhatsIncludedDialog());
            };
        }
    }
);

module.exports = internals.connect(Portfolio);



// WEBPACK FOOTER //
// ./src/routes/portfolio/containers/Portfolio.js